import { Search } from "@mui/icons-material"
import { Box, Button, IconButton, InputBase, Paper, Stack, Tooltip } from "@mui/material"
import { DataGrid, GridColDef, GridValueGetterParams } from '@mui/x-data-grid';
import { useAppDispatch, useAppSelector } from "../../redux/hooks"
import { FACILITY_VERIFICATION_STAGE, PROVIDER_VERIFICATION_STAGE } from "../../shared/interfaces/users/user.interface";
import "./Dashboard.scss"
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useEffect } from "react";
import { GetAllProviders, UpdateProviderStatus } from "../../redux/actions";
interface DashboardProviderListPropTypes {

}
const DashboardProviderList = (props: DashboardProviderListPropTypes) => {
    const all_providers = useAppSelector(state => state.all_providers)
    const dispatch = useAppDispatch();



    useEffect(() => {
        dispatch(GetAllProviders())
    }, [dispatch])

    const columns: GridColDef[] = [
        { field: 'id', headerName: 'ID', width: 90 },
        {
            field: 'email',
            headerName: 'Email',
            width: 150,
            editable: true,
        },
        {
            field: 'firstName',
            headerName: 'first name',
            width: 150,
            editable: true,
        },
        {
            field: 'lastName',
            headerName: 'first name',
            width: 150,
            editable: true,
        },
        {
            field: 'verification_stage',
            headerName: 'Verification',
            description: 'This column has a value getter and is not sortable.',
            sortable: true,
            width: 230,
            renderCell: (params: GridValueGetterParams) => {
                console.log(params, "params here")
                if (params.value === PROVIDER_VERIFICATION_STAGE.AWAITING_APPROVAL) {
                    return (<Stack
                        direction="row"
                        justifyContent="space-between"
                        style={{width: "100%"}}
                    >
                        <Box>

                            {params.value}

                        </Box>
                        <Box>
                            <Tooltip
                                title="Approve Provider"
                                placement="left"
                            >
                                <Button
                                    style={{ minWidth: "25px", width: "25px", height: "25px", margin: "0 0px 0 10px", padding: "0", borderRadius: "50px" }}
                                    variant='outlined'
                                    color='primary'
                                    onClick={() => dispatch(UpdateProviderStatus({providerId: params.row.providerId, status: PROVIDER_VERIFICATION_STAGE.APPROVED }))}
                                    >
                                    <CheckIcon />
                                </Button>
                            </Tooltip>

                            <Tooltip
                                title="Reject Provider"
                                placement="right"
                            >
                                <Button
                                    style={{ minWidth: "25px", width: "25px", height: "25px", margin: "0 0px 0 10px", padding: "0", borderRadius: "50px" }}
                                    variant='outlined'
                                    color='error'
                                    onClick={() => dispatch(UpdateProviderStatus({providerId: params.row.providerId, status: PROVIDER_VERIFICATION_STAGE.REJECTED }))}
                                    >
                                    <CloseIcon />
                                </Button>
                            </Tooltip>
                        </Box>

                    </Stack>)
                }
                else if (params.value === PROVIDER_VERIFICATION_STAGE.REJECTED) {
                    return (<Stack
                        direction="row"
                        justifyContent="space-between"
                        style={{width: "100%"}}
                    >
                        <Box>
                            {params.value}
                        </Box>
                        <Box>
                            <Tooltip
                                title="Move back to AWAITING_APPROVAL"
                                placement="left"
                            >
                                <Button
                                    style={{ minWidth: "25px", width: "25px", height: "25px", margin: "0 0px 0 10px", padding: "0", borderRadius: "50px" }}
                                    variant='outlined'
                                    color="warning"
                                    onClick={() => dispatch(UpdateProviderStatus({providerId: params.row.providerId, status: PROVIDER_VERIFICATION_STAGE.AWAITING_APPROVAL }))}
                                >
                                    <ArrowBackIcon />
                                </Button>
                            </Tooltip>
                        </Box>
                    </Stack>)
                }
                else {
                    return (<Stack
                        direction="row"
                        justifyContent="space-between"
                        style={{width: "100%"}}
                    >
                        <Box>
                            {params.value}
                        </Box>
                        <Box>
                            <Tooltip
                                title="Move back to AWAITING_APPROVAL"
                                placement="left"
                            >
                                <Button
                                    style={{ minWidth: "25px", width: "25px", height: "25px", margin: "0 0px 0 10px", padding: "0", borderRadius: "50px" }}
                                    variant='outlined'
                                    color="info"
                                    onClick={() => dispatch(UpdateProviderStatus({providerId: params.row.providerId, status: PROVIDER_VERIFICATION_STAGE.AWAITING_APPROVAL }))}
                                >
                                    <ArrowBackIcon />
                                </Button>
                            </Tooltip>
                        </Box>
                    </Stack>)
                }
            }
        },
    ];

    const rows = all_providers?.providers || [];

    return (
        <>
            <Box sx={{ height: 500, width: '100%' }}>
                <DataGrid
                    rows={rows}
                    columns={columns}
                    pageSize={10}
                    rowHeight={50}
                    disableSelectionOnClick
                />
            </Box>
        </>
    )

}

export default DashboardProviderList